import { Props as SelectProps } from "react-select";
import { useEffect, useState } from "react";

import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { Option } from "@/@types/generics/Option";
import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { getRiskClassifications } from "@/services/sintegrada/riskClassification/getRiskClassification";

import { SelectComponent } from "@/components/SelectComponent";

type Props = SelectProps & {
	noDefaultOption?: boolean;
};

export const defaultRiskClassification = {
	value: {} as RiskClassification,
	label: "Todas as Classificações",
};

export function RiskClassificationSelect({ noDefaultOption, ...rest }: Props) {
	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const [riskClassifications, setRiskClassifications] = useState<RiskClassification[]>([]);

	let options: Option<RiskClassification>[] = [
		...riskClassifications?.map((riskClassification) => ({
			value: riskClassification,
			label: riskClassification.name,
		})),
	];
	if (!noDefaultOption) {
		options = [defaultRiskClassification, ...options];
	}

	async function handleRiskClassifications() {
		setRiskClassifications(await getRiskClassifications({ uf, ibgeCode, cnes }));
	}

	useEffect(() => {
		handleRiskClassifications();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="d-flex flex-column justify-content-between">
			<label
				title="Classificação de risco"
				className="form-label"
				htmlFor="risk-classification"
			>
				Classificações de risco
			</label>

			<SelectComponent
				className="fs-8 p-0"
				options={options}
				inputId="risk-classification"
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhuma notificação encontrada"}
				{...rest}
			/>
		</div>
	);
}
